import './card-category.scss';

import { Outlet } from "react-router-dom";

import { FilterCardCategoryProvider } from "./filter-card-category/filter-card-category.context";

export function CardCategory() {
  return (
    <div id="ShellCardCategory" className="card-category">
       <FilterCardCategoryProvider>
        <Outlet />
      </FilterCardCategoryProvider>
    </div>
  );
}

export default CardCategory;
